// eslint-disable-next-line no-shadow
export enum featureToggleKeys {
  TerrAttUK = 'UK-TA',
  TerrAttNeth = 'Neth-TA',
  NotificationLogs = 'UINotiLogs',
  Birthday = 'Birthday',
  Enhancement = 'EN-API',
  MyActionsV3 = 'MyActionsV3',
  ManAuthUK = 'UK-MA',
  UkPlannerDayforceAbsence = 'UK-Planner-Dayforce-Absence',
  SplitPots = 'SPLIT-POTS',
}
